import closeCargo from "@/mixins/closeCargo";
import store from '../../store';
import {firebase} from "@/init/firebase";


const catchScanExit = async (router) => {
    router.beforeEach(async (to, from, next) => {
        if (from.name === 'loading' && to.name === 'loading-cargo-orders') {
            next();
        } else if (from.name === 'loading-cargo-orders' && to.name === 'registerDeviation') {
            next();
        } else if (from.name === 'registerDeviation' && to.name === 'loading-cargo-orders') {
            next();
        } else if (from.name === 'loading-cargo-orders' && to.name === 'loading-manual-order-product-change') {
            next();
        } else if (from.name === 'loading-manual-order-product-change' && to.name === 'loading-cargo-orders') {
            next();
        } else if(store.getters["users/getMe"] &&  await firebase.auth().currentUser && to.name === 'login') {
            console.warn("IGENORE LOGIN ROUTE");
            next({name: 'home'})
        } else {
            closeCargo();
            next();
        }
    })
}

export default catchScanExit;